<template>
  <div class="configure">
    <!-- 活动列表 -->
    <div class="line">
      <div class="flex">
        <vs-input
          class="item"
          v-model="params.activityName"
          placeholder="请输入活动名称/活动编号"
        />
        <vs-button @click.prevent="getTableData">
          查询
        </vs-button>
      </div>
      <vs-button v-if="filtering('storeactivities:config:add')" @click="addData">新增</vs-button>
    </div>
    <vs-table :data="tableData"  noDataText="暂无数据">
      <template slot="thead">
        <vs-th v-for="(headData, index) in headData" :key="index">
          {{ headData }}
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            {{ indextr + 1 }}
          </vs-td>
          <vs-td :data="tr.id">
            {{ tr.id }}
          </vs-td>
          <vs-td :data="tr.activityName">
            {{ tr.activityName }}
          </vs-td>
          <vs-td :data="tr.pushType">
          {{tr.pushType==1?'统一推送':'独立推送'}}</vs-td>
          <vs-td>
            {{ tr.type | getType }}
          </vs-td>
          <vs-td> {{ getParticipation(tr) }} ／ {{ tr.storeNum }} </vs-td>
          <vs-td>
            <span class="none" :ref="`input${indextr}`">
              {{ `id=${tr.id}` }}
            </span>
             <vs-button v-if="filtering('storeactivities:config:import')&&tr.pushType==2" color="primary" type="flat" class="btn" @click="importData(tr.id)">
              导入模板
            </vs-button>
             <vs-button v-if="filtering('storeactivities:config:export')&&tr.pushType==2" color="primary" type="flat" class="btn" @click="exportData(tr.id)">
              内容导出
            </vs-button>
            <vs-button v-if="filtering('storeactivities:config:update')" color="primary" type="flat" class="btn" @click="edit(data[indextr])">
              编辑
            </vs-button>
            <vs-button v-if="filtering('storeactivities:config:delete')" color="primary" type="flat" class="btn" @click="del(data[indextr])">
              删除
            </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!-- <gc-vs-pagination
      class="pagination"
      v-if="tableData.length"
      :total="pagination.totalPage"
      v-model="pagination.page"
      :max-items="999999999">
    </gc-vs-pagination> -->
    <gc-vs-pagination
      :pager="pagination"
      totalName="totalPage"
      pageSizeName="pageSize"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      ></gc-vs-pagination>


       <!-- 导入 -->
            <el-dialog
                title="导入模板"
                :visible.sync="showImportDialog"
                width="30%"
                class="importDiv"
            >
                <span slot="footer" class="dialog-footer" style="text-align:center;margin-top:20px;">
                <p style="line-height:30px;">导入数据以门店编码为准，请仔细填写!</p>
                  <el-upload
                      ref="upload"
                      class="upload-demo"
                      action='/data-dist/api/dist/activityConfig/importAlonePushConfig'
                      :accept="accept"
                      :show-file-list="false"
                      :limit="1000"
                      :data="exitParam"
                      :on-success="uploadSuccess"
                      :headers="tokenHeader"
                      :before-upload="handleBefore">

                        <vs-button color="primary" type="filled" class="browse-btn">浏览</vs-button>
                       <div style="margin-top:20px;color:#409EFF" @click.stop="downloadTemplate()">下载文件模板</div>
                       <!-- <el-button style="margin-top:20px;" @click="downloadTemplate()">下载文件模板</el-button> -->

                    </el-upload>
                </span>
            </el-dialog>
  </div>
</template>

<script>
import { DistributionApi } from "@/modules/server-api/commodity-sys/distribution.ts";
import constants from "../../../constants.ts";
import {downloadExcel, downloadFileTemplate} from "@/utils/downloadExcel.js";
import {$busErrorCode, uploadHeader} from "@/modules/commodity-sys/common.js";
export default {
  props:{
    pageSize:{
      default:20,
      type: Number
    }
  },
  data() {
    return {
      exitParam:{
        configId:''
      },
      configId:'',
      accept:'.xlsx',
      showImportDialog:false,
      params: { activityName: "",  id: "" },
      options: [
        { label: "关闭", code: 1 },
        { label: "开启", code: 2 }
      ],
      headData: [
        "序号",
        "活动编号",
        "活动名称",
        "推送类型",
        "活动类型",
        "参与门店/覆盖门店",
        "活动操作"
      ],
      tableData: [],
      tokenHeader: uploadHeader,
      pagination: {
        totalPage: 1,
        page: 1,
        pageSize: this.pageSize
      }
    };
  },
  filters: {
    getStatus(val) {
      let text = "--";
      switch (val) {
        case 1:
          text = "关闭";
          break;
        case 2:
          text = "开启";
      }
      return text;
    },
    getType(val) {
      const item = constants.typeOptions.find(({ value }) => value === val) || {};
      return item.label;
    },

  },
  watch: {
      // 'pagination.page'() {
      //     this.getTableData();
      // }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getParticipation(tr) {
      let ret = tr.userNum;
      if (tr.type == 1) {
        ret = '-';
      }
      return ret;
    },
    addData() {
      const path = `storeactivities/configure/0`;
      this.$router.push(path);
    },
    getTableData() {
       this.$vs.loading();
      const { code = 0 } = this.params.status || {};
      DistributionApi.activityConfigList({
        ...this.params,
        page: this.pagination.page - 1,
        size: this.pagination.pageSize,
        type: [1, 2,3],    // 1=宣传/2=核销/3=报名
        status: 1,
        id: 0
      }).then(({ result = {} }) => {
        const { data = [], totalPage, totalElements } = result;
        this.tableData = data;
        //this.pagination.totalPage = totalPage
        this.pagination.totalPage = totalElements
       this.$vs.loading.close();
      });
    },
    edit({ id = "" }) {
      const path = `storeactivities/configure/${id}`;
      this.$router.push({ path });
    },
    // 删除
    async del(item) {
      const res = await DistributionApi.queryEntranceIsDelete({
        id: item.id
      })
      console.log('res',res)
      if(res.succ === 1 && res.result) {
        return this.$notifyError('该项已在门店活动中添加配置，无法删除');
      }
      console.log('item',item)
      this.$vs.dialog({
        type: 'confirm',
        color: '#4090FF',
        title: `提示`,
        text: '确定要删除此项么?',
        acceptText: '确认',
        cancelText: '取消',
        accept: async () => {
          const res = await DistributionApi.deleteActive({configId: item.id})
          console.log('2222',res)
          if(res.succ === 1) {
            this.$notifyError('删除失败');
          } else {
            this.$notifySuccess('删除成功');
          }
          this.getTableData()
        }
      })
    },
    copy(row, index) {
      const oInput = this.$refs[`input${index}`][0];
      const range = document.createRange();
      range.selectNode(oInput);
      const selection = window.getSelection();
      if (selection.rangeCount > 0) selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
    },
    saveDate(val) {
      this.params.date = val;
    },
    //更改每页条数
    handleSizeChange(val){
      this.pagination.pageSize = val;
      this.$emit("changePageSize", val);
      this.getTableData();
    },
    handleCurrentChange(val){
      this.pagination.page = val;
      this.getTableData();
    },
     //下载文件模板
    downloadTemplate() {
        let url = '/data-dist/api/dist/activityConfig/getAlonePushExcel?type=0&configId='+this.configId;
        let name = '门店活动导入模板.xlsx';
        downloadFileTemplate(url, name);
    },
    //导入文件
    uploadSuccess(response) {
      console.log('response',response)
        if (response.code == 0 && response.code != $busErrorCode) {
                // console.log()
            this.$notifySuccess('导入成功');
            this.getTableData();
            this.showImportDialog = false;
        } else {
            this.$notifyError(response.error || '导入数据错误,请修改后重新上传');
            this.showImportDialog = false;
        }
      },
    handleBefore(){
      this.exitParam.configId=this.configId
    },
    //导入
    importData(id){
      this.configId=id
      this.showImportDialog=true
    },
    //导出
    async exportData(id) {
      // let param={
      //   type:1,
      //   configId:id
      // }
      // let url = '/data-dist/api/dist/activityConfig/getAlonePushExcel';
      // let fileName = '列表导出.xlsx';
      // downloadExcel(url, param, fileName);

        let url = '/data-dist/api/dist/activityConfig/getAlonePushExcel?type=1&configId='+id;
        let name = '列表导出.xlsx';
        downloadFileTemplate(url, name);
    },
  }
};
</script>

<style scoped lang="scss">
.line {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
.item {
  margin-right: 10px;
  width:200px;
}
.none {
  // opacity: 0;
  display: none;
}
.configure {
  .vs-button {
    padding: 6px 24px !important;
  }
  .btn{
    padding: 2px 15px !important;
  }
  .pagination {
    margin-top:15px;
  }
}
.importDiv /deep/.el-dialog__footer{
margin-top: 20px;
}
.importDiv /deep/.el-dialog{
height: 200px;
}
.importDiv /deep/.el-dialog__body{
  height: 0px;
  padding: 0px 0px;

}
</style>
